export default __webpack_public_path__ + "static/media/FAQ.8ed8430c.svg";